import { render, staticRenderFns } from "./AllPresales.vue?vue&type=template&id=d684e54e&scoped=true&"
import script from "./AllPresales.vue?vue&type=script&lang=ts&"
export * from "./AllPresales.vue?vue&type=script&lang=ts&"
import style0 from "./AllPresales.vue?vue&type=style&index=0&id=d684e54e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d684e54e",
  null
  
)

export default component.exports